'use client';
import { useEffect, useState } from 'react';

import { Accordion } from '@gds/Accordion/Accordion';
import { Datasheet } from '@gds/Icons';

import { FeatureLists } from '../FeatureLists/FeatureLists';
import { MobileViewContainer } from '../MobileViewContainer/MobileViewContainer';
import { VehicleHighlightProps } from '../PdpOverview.entity';

import styles from '../PdpOverview.module.css';

interface DescriptionProps extends VehicleHighlightProps {
  defaultOpen?: boolean;
}

export const Description = ({
  vehicle: {
    spec: { featureList: { description } = {} },
  },
  messages: { descriptionHeader },
  defaultOpen = false,
}: DescriptionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  useEffect(() => {
    const checkHash = () => {
      if (typeof window !== 'undefined' && window.location.hash === '#vehicle-description') {
        setIsOpen(true);
      }
    };
    checkHash();
    window.addEventListener('hashchange', checkHash);

    return () => {
      window.removeEventListener('hashchange', checkHash);
    };
  }, []);
  if (!description || !description?.length) return null;

  const RenderDescriptionContent = () => {
    return <FeatureLists features={description} isHtmlList />;
  };

  return (
    <>
      <Accordion
        title={descriptionHeader}
        titleIcon={<Datasheet />}
        className={styles.hideSectionForTblt}
        open={isOpen}
        onExpandedChange={newState => setIsOpen(newState)}
      >
        <RenderDescriptionContent />
      </Accordion>
      <MobileViewContainer
        title={descriptionHeader}
        content={<RenderDescriptionContent />}
        titleIcon={<Datasheet />}
      />
    </>
  );
};
